import styled from 'styled-components';

export default styled.div`
  display: grid;
  grid-auto-flow: column;
  float: right;
`;
